import { formatAmount, formatNumber } from '@cp/src/utils/commonUtils';
import { IPtpsOverviewMTD } from '../../constants/interface';
import commonStyles from './chart.module.scss';

export const getPtpsOverviewChartOptions = (ptpsOverviewMTD?: IPtpsOverviewMTD) => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      style: {
        fontFamily: 'Inter'
      },
      renderTo: 'container',
      height: 240,
      width: 260
    },
    credits: {
      enabled: false
    },
    title: {
      useHTML: true,
      text: `<div class="flex flex-col items-center">
                <div class='${commonStyles.chartTitle}'>Unpaid Cases</div>
                <div class='${commonStyles.chartCount}'>${formatNumber(
        ptpsOverviewMTD?.totalUnpaidCases ?? 0
      )}</div>
                <div class='${commonStyles.chartAmount}'>(${formatAmount(
        ptpsOverviewMTD?.totalUnpaidEmiAmount
      )})</div>
              </div>`,
      align: 'center',
      verticalAlign: 'middle'
    },
    tooltip: {
      enabled: false
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        size: 180,
        dataLabels: {
          enabled: false
        }
      },
      series: {
        events: {
          click: function (e: any) {}
        }
      }
    },
    series: [
      {
        type: 'pie',
        innerSize: '80%',
        data: [
          {
            y: ptpsOverviewMTD?.brokenPtp?.count,
            name: 'brokenPtp',
            url: '/cases',
            color: 'var(--red-base)'
          },
          {
            y: ptpsOverviewMTD?.todayPtp?.count,
            name: 'todayPtp',
            url: '/cases',
            color: 'var(--yellow-base)'
          },
          {
            y: ptpsOverviewMTD?.futurePtp?.count,
            name: 'futurePtp',
            url: '/cases',
            color: 'var(--orange-base)'
          },
          {
            y: ptpsOverviewMTD?.noPtp?.count,
            name: 'noPtp',
            url: '/cases',
            color: 'var(--navi-toast-spinner-color-empty-area)'
          }
        ],
        states: {
          inactive: {
            opacity: 1
          },
          hover: {
            enabled: false
          }
        }
      }
    ]
  };
};
